import { SessionStorageKeyType } from 'models';

export function saveToSessionStorage(key: SessionStorageKeyType, value?: unknown) {
	sessionStorage.setItem(key, JSON.stringify(value));
}
